import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button, Form, Pagination, Row, Select, Space, Table, Typography, message, Modal as AntModal, Col, Divider } from "antd";
import type { PaginationProps, TableProps } from "antd";
import "./ManualVolume.css";
import { BsPencilSquare } from "react-icons/bs";
import { usePagination } from "src/hook/usePagination";
import { useDidMount } from "src/hook/useDidMount";
import { useShallow } from "zustand/react/shallow";
import { CloseOutlined } from "@ant-design/icons";
import { CommonSuccess } from "src/entity/common/menus-enum.enum";
import { InfoCircleOutlined } from "@ant-design/icons";
import { profileStore } from "src/stores/profile-store";
import { formatNumber } from "src/utils/process-number";
import { InputByFixed, UnitAllEnum } from "src/entity/common/unit.constant";
import { componentPalette } from "src/theme/component-palette";
import { flareVolumeStore } from "src/stores/flare-volume-store";
import { utilsStore } from "src/stores/utils-store";
import { cloneDeep, omitBy, isNull, omit } from "lodash";
import ManualVolumeModal from "./ManualVolumeModal";
import { manualFlareStore } from "src/stores/manual-flare-store";
import {
  AttributeManualFlareMonthly,
  FilterManualFlareVolume,
  ManualFlareMonthly,
  ResponseManualFlareVolume,
  ResponseManualFlareVolumeForEditor,
  UpdateManualFlareVolume,
} from "src/entity/flare/manual-flare-volume.entity";
import { reportFlareStore } from "src/stores/report-flare-volume-store";
import { FlareCaseEnum, GAS_UNIT, getFlareCaseDisplayLabel } from "src/entity/flare/flare.constants";
import useNavigationMenu from "src/hook/useNavigationMenu";
import { canEditTable, canViewTable } from "src/pages/VocsInventory/Flare/PermissionCheck/PermissionCheck";
import { getFilterWithEmptyMasterdata } from "src/utils/utils-object";
import { KeyofMonthly } from "src/entity/common/global.entity";
import { optionsSelectYears } from "src/utils/array";
import Search, { SearchProps } from "antd/es/input/Search";
import { addCenterAlign } from "src/components/AntdCustomPart/TableTitle.tsx/TableTitle";

const { Text } = Typography;
interface ManualVolumeTableProps {}

const ManualVolumeTable: React.FC<ManualVolumeTableProps> = ({}) => {
  const currentYear = new Date().getFullYear();
  const [messageApi, contextHolder] = message.useMessage();

  const prevCompany: any = useRef();

  const [selectedYear, setSelectedYear] = useState<string>(currentYear.toString());
  const [visibleModal, setVisibleModal] = useState(false);
  const [isEdit, setIsEdit] = useState<ResponseManualFlareVolumeForEditor | null>(null);
  const [tableKey, setTableKey] = useState(0);
  const { permissions } = useNavigationMenu();

  const profile = profileStore(useShallow((state) => state.profile));
  const loadingProfile = profileStore(useShallow((state) => state.loading));

  const getAreaInCompany = utilsStore(useShallow((state) => state.getAreaInCompany));
  const dataAreaInCompany = utilsStore(useShallow((state) => state.dataAreaInCompany));

  const setLoadingAll = flareVolumeStore(useShallow((state) => state.setLoadingAll));
  const loadingAll = flareVolumeStore(useShallow((state) => state.loadingAll));
  const getAllHeatingValue = flareVolumeStore(useShallow((state) => state.getAllHeatingValue));
  const dataHeatingValueAll = flareVolumeStore(useShallow((state) => state.dataHeatingValueAll));
  const getAllSettingFlareInformation = flareVolumeStore(useShallow((state) => state.getAllSettingFlareInformation));
  const dataFlareInfo = flareVolumeStore(useShallow((state) => state.dataFlareInfo));
  const loadingGet = manualFlareStore(useShallow((state) => state.loadingGet));
  const searchManualFlareVolume = manualFlareStore(useShallow((state) => state.searchManualFlareVolume));
  const dataManual = manualFlareStore(useShallow((state) => state.dataManual));
  const totalDocs = dataManual.total;
  const getFilterManualFlareVolume = manualFlareStore(useShallow((state) => state.getFilterManualFlareVolume));
  const dataFilterManualFlareVolume = manualFlareStore(useShallow((state) => state.filterManualFlareVolume));
  const loadingManageFlareVolume = manualFlareStore(useShallow((state) => state.loadingManage));
  const updateManualFlareVolume = manualFlareStore(useShallow((state) => state.updateManualFlareVolume));
  const calculateReportFlareVolume = reportFlareStore(useShallow((state) => state.calculateReportFlareVolume));
  const clearError = manualFlareStore(useShallow((state) => state.clearError));
  const errorFlareVolume = manualFlareStore(useShallow((state) => state.error));

  // Text Search
  const [textSearch, setTextSearch] = useState<string>("");
  const [searchTrigger, setSearchTrigger] = useState(0);

  //   console.log(" filterFlareVolume : ", filterFlareVolume);
  //   console.log("dataHeatingValueAll : ");

  const onClickEdit = (_id: string) => {
    const groupFlare = (sourceData as ResponseManualFlareVolume[]).filter((item) => item._id === _id);
    const normal = groupFlare.find((item) => item.flareCase === FlareCaseEnum.NORMAL_OPERATE);
    const turnaround = groupFlare.find((item) => item.flareCase === FlareCaseEnum.TURNAROUND);
    const emergency = groupFlare.find((item) => item.flareCase === FlareCaseEnum.EMERGENCY);
    let tmpEditor: ResponseManualFlareVolumeForEditor = {
      ...omit(groupFlare[0], ["flareCase", "flareVolumeMonthly", "no"]),
      manualFlareVolume: {
        normalOperate: normal?.flareVolumeMonthly as ManualFlareMonthly,
        turnaround: turnaround?.flareVolumeMonthly as ManualFlareMonthly,
        emergency: emergency?.flareVolumeMonthly as ManualFlareMonthly,
      },
    };

    setIsEdit(tmpEditor);
    setVisibleModal(true);
  };

  const mappingWarningText = (error: string, _: number): string => {
    return `• ${error}\n`;
  };

  const warningAlert = (message: string | string[]) => {
    const warnModal = AntModal.confirm({
      title: (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>Can not save the data</span>
          <CloseOutlined onClick={() => warnModal.destroy()} style={{ cursor: "pointer" }} />
        </div>
      ),
      content: typeof message === "string" ? `• ${message}` : message.map(mappingWarningText),
      okText: "OK",
      icon: <InfoCircleOutlined style={{ color: componentPalette.redThird }} />,
      okButtonProps: { style: { textAlign: "center", backgroundColor: componentPalette.primary } },
      cancelButtonProps: { style: { display: "none" } },
      onOk: () => {},
      className: "custom-tmp-modal-warning",
    });
  };

  const {
    onChange,
    filter,
    page,
    setPage,
    loading,
    limit: pageSize,
    setLimit: setPageSize,
    data: sourceData,
    replaceFilter,
  } = usePagination<ResponseManualFlareVolume, FilterManualFlareVolume>({
    action: searchManualFlareVolume,
    remoteData: dataManual.data,
    initialFilter: { year: [selectedYear], inputBy: [InputByFixed[1].value] },
  });

  const currentFilterExcludePage = useMemo(() => {
    const result = omitBy(filter, (value, key) => key === "page" || key === "year" || key === "limit" || isNull(value));
    return Object.keys(result).length;
  }, [filter]);

  const getMasterLabel = useCallback(
    (type: string, text: string) => {
      if (!text || typeof text != "string") return "";

      if (type === "gasName" && dataHeatingValueAll) {
        const optValue = dataHeatingValueAll.find((item) => item._id === text);
        return optValue?.gasName;
      } else if (type === "area" && dataAreaInCompany) {
        const optValue = dataAreaInCompany.find((item) => item._id === text);
        return optValue?.areaName;
      } else if (type === "flareName" && dataFlareInfo) {
        const optValue = dataFlareInfo.find((item) => item._id === text);
        return optValue?.flareName;
      } else if (type === "unit" && dataHeatingValueAll) {
        const optValue = dataHeatingValueAll.find((item) => item._id === text);
        return optValue?.unitHeatingValue === GAS_UNIT.KCAL_KG ? UnitAllEnum.KG : UnitAllEnum.M3;
      } else return text;
    },
    [dataFlareInfo, dataAreaInCompany, dataHeatingValueAll.length],
  );

  const gasNameFilter = useMemo(() => {
    if ((dataManual.data?.length === 0 || dataFilterManualFlareVolume.gasName?.length === 0) && currentFilterExcludePage == 0) return [];
    return getFilterWithEmptyMasterdata(dataHeatingValueAll, dataFilterManualFlareVolume.gasName, "gasName");
  }, [dataHeatingValueAll, dataFilterManualFlareVolume.gasName, dataManual.data]);
  const sourceNameFilter = useMemo(() => {
    if ((dataManual.data?.length === 0 || dataFilterManualFlareVolume.sourceName?.length === 0) && currentFilterExcludePage == 0) return [];
    return dataFilterManualFlareVolume.sourceName.map((item) => {
      return {
        text: item,
        value: item,
      };
    });
  }, [dataFilterManualFlareVolume.sourceName, dataManual.data]);
  const areaFilter = useMemo(() => {
    if ((dataManual.data?.length === 0 || dataFilterManualFlareVolume.area?.length === 0) && currentFilterExcludePage == 0) return [];
    return getFilterWithEmptyMasterdata(dataAreaInCompany, dataFilterManualFlareVolume.area, "areaName");
  }, [dataAreaInCompany, dataFilterManualFlareVolume.area, dataManual.data]);
  const flareNameFilter = useMemo(() => {
    if ((dataManual.data?.length === 0 || dataFilterManualFlareVolume.flareName?.length === 0) && currentFilterExcludePage == 0) return [];

    return getFilterWithEmptyMasterdata(dataFlareInfo, dataFilterManualFlareVolume.flareName, "flareName");
  }, [dataFlareInfo, dataFilterManualFlareVolume.flareName, dataManual.data]);

  const handleTableChange: TableProps<ResponseManualFlareVolume>["onChange"] = (_, filters) => {
    onChange(filters);
  };

  const getIndex = (index: number) => (page - 1) * pageSize + index;

  const columns: TableProps<ResponseManualFlareVolume>["columns"] = [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
      render: (text, record, index) => {
        const obj = {
          children: <Text>{getIndex(+text)}</Text>,
          props: {
            rowSpan: 1,
          },
        };
        if (index === 0 || (sourceData as any)[index - 1]._id !== record._id) {
          obj.props.rowSpan = (sourceData as any).filter((item: any) => item._id === record._id).length;
        } else {
          obj.props.rowSpan = 0;
        }
        return obj;
      },
      align: "left",
    },
    {
      title: "Source Name",
      dataIndex: "sourceName",
      key: "sourceName",
      render: (text, record, index) => {
        const obj = {
          children: <Text>{text}</Text>,
          props: {
            rowSpan: 1,
          },
        };
        if (index === 0 || (sourceData as any)[index - 1]._id !== record._id) {
          obj.props.rowSpan = (sourceData as any).filter((item: any) => item._id === record._id).length;
        } else {
          obj.props.rowSpan = 0;
        }
        return obj;
      },
      filters: sourceNameFilter,
      align: "left",
    },
    {
      title: "Gas Name",
      dataIndex: "gasName",
      key: "gasName",
      render: (text, record, index) => {
        const obj = {
          children: <Text>{getMasterLabel("gasName", text)}</Text>,
          props: {
            rowSpan: 1,
          },
        };
        if (index === 0 || (sourceData as any)[index - 1]._id !== record._id) {
          obj.props.rowSpan = (sourceData as any).filter((item: any) => item._id === record._id).length;
        } else {
          obj.props.rowSpan = 0;
        }
        return obj;
      },
      filters: gasNameFilter,
      align: "left",
    },
    {
      title: "Area",
      dataIndex: "area",
      key: "area",
      render: (text, record, index) => {
        const obj = {
          children: <Text>{getMasterLabel("area", text)}</Text>,
          props: {
            rowSpan: 1,
          },
        };
        if (index === 0 || (sourceData as any)[index - 1]._id !== record._id) {
          obj.props.rowSpan = (sourceData as any).filter((item: any) => item._id === record._id).length;
        } else {
          obj.props.rowSpan = 0;
        }
        return obj;
      },
      filters: areaFilter,
      align: "left",
    },
    {
      title: "Flare Name",
      dataIndex: "flareName",
      key: "flareName",
      render: (text, record, index) => {
        const obj = {
          children: <Text>{getMasterLabel("flareName", text)}</Text>,
          props: {
            rowSpan: 1,
          },
        };
        if (index === 0 || (sourceData as any)[index - 1]._id !== record._id) {
          obj.props.rowSpan = (sourceData as any).filter((item: any) => item._id === record._id).length;
        } else {
          obj.props.rowSpan = 0;
        }
        return obj;
      },
      filters: flareNameFilter,
      align: "left",
    },
    {
      title: "Flare Case",
      dataIndex: "flareCase",
      key: "flareCase",
      render: (text) => <Text>{getFlareCaseDisplayLabel(text)}</Text>,
      align: "left",
    },
    {
      title: "Unit",
      key: "unit",
      render: (_, record) => (
        <Col>
          <div className="text-start">
            <Text>{getMasterLabel("unit", record.gasName)}</Text>
          </div>
        </Col>
      ),
      align: "left",
    },
    {
      title: "Jan",
      key: "jan",
      render: (_, record) => <Text>{formatNumber(record.flareVolumeMonthly["jan"].value as number)}</Text>,
      align: "left",
    },
    {
      title: "Feb",
      key: "feb",
      render: (_, record) => <Text>{formatNumber(record.flareVolumeMonthly["feb"].value as number)}</Text>,
      align: "left",
    },
    {
      title: "Mar",
      key: "mar",
      render: (_, record) => <Text>{formatNumber(record.flareVolumeMonthly["mar"].value as number)}</Text>,
      align: "left",
    },
    {
      title: "Apr",
      key: "apr",
      render: (_, record) => <Text>{formatNumber(record.flareVolumeMonthly["apr"].value as number)}</Text>,
      align: "left",
    },
    {
      title: "May",
      key: "may",
      render: (_, record) => <Text>{formatNumber(record.flareVolumeMonthly["may"].value as number)}</Text>,
      align: "left",
    },
    {
      title: "Jun",
      key: "jun",
      render: (_, record) => <Text>{formatNumber(record.flareVolumeMonthly["jun"].value as number)}</Text>,
      align: "left",
    },
    {
      title: "Jul",
      key: "jul",
      render: (_, record) => <Text>{formatNumber(record.flareVolumeMonthly["jul"].value as number)}</Text>,
      align: "left",
    },
    {
      title: "Aug",
      key: "aug",
      render: (_, record) => <Text>{formatNumber(record.flareVolumeMonthly["aug"].value as number)}</Text>,
      align: "left",
    },
    {
      title: "Sep",
      key: "sep",
      render: (_, record) => <Text>{formatNumber(record.flareVolumeMonthly["sep"].value as number)}</Text>,
      align: "left",
    },
    {
      title: "Oct",
      key: "oct",
      render: (_, record) => <Text>{formatNumber(record.flareVolumeMonthly["oct"].value as number)}</Text>,
      align: "left",
    },
    {
      title: "Nov",
      key: "nov",
      render: (_, record) => <Text>{formatNumber(record.flareVolumeMonthly["nov"].value as number)}</Text>,
      align: "left",
    },
    {
      title: "Dec",
      key: "dec",
      render: (_, record) => <Text>{formatNumber(record.flareVolumeMonthly["dec"].value as number)}</Text>,
      align: "left",
    },
    {
      title: "Total",
      key: " total",
      render: (_, record) => <Text>{formatNumber(record.flareVolumeMonthly.total as number)}</Text>,
      align: "left",
    },
    {
      title: "Action",
      key: "action",

      render: (text, record, index) => {
        const obj = {
          children: (
            <Space size="middle" direction={"horizontal"}>
              <Button
                className="border-transparent bg-transparent"
                size={"small"}
                onClick={() => onClickEdit(record._id)}
                disabled={!canEditTable(permissions)}
              >
                <BsPencilSquare size={18} />
              </Button>
            </Space>
          ),
          props: {
            rowSpan: 1,
          },
        };
        if (index === 0 || (sourceData as any)[index - 1].no !== record.no) {
          obj.props.rowSpan = (sourceData as any).filter((item: any) => item.no === record.no).length;
        } else {
          obj.props.rowSpan = 0;
        }
        return obj;
      },
      align: "left",
    },
  ];

  const initialRequestDidMount = async (isDidMount?: boolean) => {
    setLoadingAll(true);

    const getAreaInCompanyPromise = getAreaInCompany(profile?.activeCompany._id as string); // area
    const getAllSettingFlareInformationPromise = getAllSettingFlareInformation(); // flare name
    const getAllHeatingValuePromise = getAllHeatingValue(selectedYear); // gas name
    const getFilterManualFlareVolumePromise = getFilterManualFlareVolume(selectedYear);
    const searchManualFlareVolumePromise = searchManualFlareVolume(
      isDidMount === true
        ? { ...filter, page, limit: pageSize, year: [selectedYear] }
        : { page, limit: pageSize, year: [selectedYear], inputBy: [InputByFixed[1].value] },
    );

    await Promise.all([
      getAreaInCompanyPromise,
      getAllSettingFlareInformationPromise,
      getAllHeatingValuePromise,
      getFilterManualFlareVolumePromise,
      searchManualFlareVolumePromise,
    ]);

    setLoadingAll(false);
  };

  useDidMount(() => {
    prevCompany.current = profile?.activeCompany._id;
    initialRequestDidMount(true);
  });

  useEffect(() => {
    if (profile?.activeCompany) {
      if (prevCompany.current !== profile.activeCompany._id) {
        replaceFilter({ year: [currentYear.toString()], inputBy: [InputByFixed[1].value] });
        setSelectedYear(currentYear.toString());
        prevCompany.current = profile?.activeCompany._id;
      }
      setPage(1);
      setTableKey(tableKey + 1);
      setTextSearch("");
    }
  }, [profile?.activeCompany, selectedYear]);

  useEffect(() => {
    if (tableKey > 0) {
      initialRequestDidMount(false);
    }
  }, [tableKey]);

  useEffect(() => {
    searchManualFlareVolume({ ...filter, textSearch, page: 1, limit: pageSize, year: [selectedYear] });
  }, [searchTrigger]);

  const onChangePage = (val: number) => {
    setPage(val);
  };

  const paginationProps: PaginationProps = {
    size: "small",
    pageSize: pageSize,
    current: page,
    total: totalDocs || 0,
    defaultCurrent: 1,
    onChange: onChangePage,
    showSizeChanger: false,
  };

  const closeModal = () => {
    setVisibleModal(false);
    clearError("error");
    setIsEdit(null);
  };

  const submitSetupHeatingValue = async () => {
    if (!isEdit || !isEdit._id || !isEdit.manualFlareVolume) return;
    // console.log("isEdit : ", isEdit);
    const finalData: UpdateManualFlareVolume = {
      _id: isEdit?._id,
      manualFlareVolume: isEdit?.manualFlareVolume,
    };
    updateManualFlareVolume(finalData).then(onFinishAction);
  };

  const handleChangeYear = (year: string) => {
    // console.log("Year : ", year);
    replaceFilter({ year: [year], inputBy: [InputByFixed[1].value] });
    setSelectedYear(year);
  };

  const onFinishAction = (errorMessage?: unknown) => {
    // console.log("errorMessage : ", errorMessage);
    if (errorMessage) {
      warningAlert(errorMessage as string);
      return;
    } else {
      calculateReportFlareVolume(isEdit?._id as string);
      messageApi.open({
        type: "success",
        content: CommonSuccess.SAVED_SUCCESSFULL,
      });
      searchManualFlareVolume({ ...filter, page, limit: pageSize, year: [selectedYear], inputBy: [InputByFixed[1].value] });
      closeModal();
    }
  };

  const setUpManualVolume = (month: keyof ManualFlareMonthly, type: keyof AttributeManualFlareMonthly, value: number | string) => {
    const tmpState = cloneDeep(isEdit);
    if (tmpState && tmpState.manualFlareVolume) tmpState.manualFlareVolume[type][month as keyof KeyofMonthly].value = `${value}`;
    setIsEdit(tmpState as ResponseManualFlareVolumeForEditor);
  };

  const onSearch: SearchProps["onSearch"] = (value, _e) => {
    setTextSearch(value);
    setSearchTrigger((prev) => prev + 1);
  };

  return (
    <Row className="w-full" id={"wrap-manual-volume-table"}>
      {contextHolder}
      <Row className="w-full" justify={"center"} align={"middle"}>
        <Col span={6}>
          <Select value={selectedYear} style={{ width: 120 }} onChange={handleChangeYear} options={optionsSelectYears()} size="middle" />
        </Col>
        <Col span={12} style={{ display: "flex", justifyContent: "center" }}>
          <Search
            onSearch={onSearch}
            style={{ width: 250 }}
            value={textSearch}
            onChange={(e) => setTextSearch(e.target.value)}
            allowClear
          />
        </Col>
        <Col span={6}></Col>
      </Row>
      <Table
        key={tableKey}
        columns={addCenterAlign(columns)}
        dataSource={canViewTable(permissions) ? (sourceData as ResponseManualFlareVolume[]) : []}
        className="w-full mt-4"
        loading={loadingProfile || loadingAll || loading || loadingGet}
        rowKey={(record, index) => `${record._id}-${index}-${record.no}`}
        scroll={{ x: "max-content" }}
        pagination={false}
        onChange={handleTableChange}
      />

      {canViewTable(permissions) ? (
        <Row className="w-full mt-4" justify={"end"}>
          <Pagination {...paginationProps} />
        </Row>
      ) : (
        <></>
      )}

      <ManualVolumeModal
        submitSetupHeatingValue={submitSetupHeatingValue}
        loadingManageFlareVolume={loadingManageFlareVolume}
        visibleModal={visibleModal}
        closeModal={closeModal}
        error={errorFlareVolume}
        isEdit={isEdit}
        setUpManualVolume={setUpManualVolume}
        getMasterLabel={getMasterLabel}
      />
    </Row>
  );
};

export default ManualVolumeTable;
